<template>
  <intro-template
    @start="next"
    button-label="Commencer"
    duration="2">
    <template v-slot:module-title>
      Gérer l'arrivée ou le départ d'un collaborateur
    </template>
    <template v-slot:learnings-title>
      Dans ce module, vous allez apprendre à...
    </template>
    <template v-slot:learnings>
      <p>Maîtriser la procédure de l'arrivée ou du départ d'un collaborateur</p>
      <p>Créer un planning pour un nouveau collaborateur</p>
      <p>Transmettre les informations utiles au Solde Tout Compte</p>
    </template>
    <template v-slot:rules>
      <div class="rule">
        <p class="label">
          Faites le bon choix
        </p>
        <p class="value">
          à chaque étape de la procédure
        </p>
      </div>
    </template>
  </intro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Intro',
  mixins: [stepMixin]
}
</script>
